import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { InvoiceEntity } from './invoice.entity';
import { MPaymentTransactionEntity } from './m-payment-transaction.entity';

@Index(
	'm_sm_payment_externalId_deleted_userId',
	['deletedUserId', 'mSmPaymentExternalId'],
	{},
)
@Index('m_sm_payment_fk_invoice__id', ['mSmPaymentFkInvoiceId'], {})
@Index(
	'm_sm_payment_fk_m_payment_transaction__id',
	['mSmPaymentFkMPaymentTransactionId'],
	{},
)
@Entity(
	'm_sm_payment_transaction_invoice',
	{},
	{ label: 'Payment Transaction Invoice' },
)
export class MSmPaymentTransactionInvoiceEntity extends BaseEntity {
	@Column('varchar', {
		name: 'm_sm_payment_externalId',
		nullable: true,
		length: 64,
	})
	public mSmPaymentExternalId!: string | null;

	@Column('int', {
		name: 'm_sm_payment_fk_m_payment_transaction__id',
		unsigned: true,
	})
	public mSmPaymentFkMPaymentTransactionId!: number;

	@Column('int', { name: 'm_sm_payment_fk_invoice__id', unsigned: true })
	public mSmPaymentFkInvoiceId!: number;

	@Column('decimal', { name: 'm_sm_payment_amount', precision: 13, scale: 2 })
	public mSmPaymentAmount!: string;

	@ManyToOne(
		() => MPaymentTransactionEntity,
		(mPaymentTransaction) => mPaymentTransaction.mSmPaymentTransactionInvoices,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{
			name: 'm_sm_payment_fk_m_payment_transaction__id',
			referencedColumnName: 'id',
		},
	])
	public mSmPaymentFkMPaymentTransaction!: MPaymentTransactionEntity;

	@ManyToOne(
		() => InvoiceEntity,
		(invoice) => invoice.mSmPaymentTransactionInvoices,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: 'm_sm_payment_fk_invoice__id', referencedColumnName: 'id' },
	])
	public mSmPaymentFkInvoice!: InvoiceEntity;
}
